import axios from 'axios';

const ContactService = {
  async getContacts(servicerId) {
    const response = await axios.get('/contact', {
      params: {
        servicer_id: servicerId,
      },
    });

    return response.data;
  },

  async createContact({ formValues, servicerId, type }) {
    const response = await axios.post('/contact', {
      ...formValues,
      servicer_id: servicerId,
      type,
    });

    return response.data;
  },

  async updateContact({ formValues, contactId, type }) {
    const response = await axios.patch(`/contact/${contactId}`, {
      ...formValues,
      type,
    });

    return response.data;
  },
};

export default ContactService;
